<template>
  <ValidationProvider
    :name="valid.name"
    :rules="valid.rules"
    v-slot="{ errors }"
    tag="div"
    class="form-group"
  >
    <p class="label">{{ title }}</p>
    <div class="form-control mb-6">
      <v-text-field
        v-model="innerValue"
        outlined
        ref="input"
        hide-details
        :error="errors.length > 0"
        :placeholder="placeholder"
        @input="$emit('update:inputValue', $event.trim())"
        :oninput="oninput"
        :inputmode="inputmode"
      ></v-text-field>
      <v-slide-y-transition>
        <p class="guide-error position--absolute" :class="{ 'opacity-0': errors.length < 1 }">
          {{ errors[0] }}
        </p>
      </v-slide-y-transition>
    </div>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    inputValue: {
      type: String,
      default: '',
    },

    /**
     * {
     *   name: 'email',
     *   rules: 'required|email|email_duplicate'
     * }
     */
    valid: {
      type: Object,
      required: true,
    },

    title: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    tabindex: {
      type: String,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    oninput: {
      type: String,
      default: null,
    },
    inputmode: {
      type: String,
      default: 'text',
    },
  },
  data() {
    return {
      innerValue: this.inputValue,
    }
  },
  watch: {
    inputValue: {
      handler(v) {
        this.innerValue = v
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped></style>
